import { render, staticRenderFns } from "./RemessaBoletoEnvio.vue?vue&type=template&id=79191031"
import script from "./RemessaBoletoEnvio.vue?vue&type=script&lang=js"
export * from "./RemessaBoletoEnvio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports